import textPageLoginTH from './pages/login/TH.json'
import textButtonTH from './pages/button/TH.json'
import textHeaderTH from './pages/header/TH.json'
import textRoomTH from './pages/room/TH.json'
import textAdvanceSearchTH from './pages/advanceSearch/TH.json'
import textLocationTH from './pages/location/TH.json'
import textUserTH from './pages/user/TH.json'
import textRoleTH from './pages/role/TH.json'
import textProfileTH from './pages/profile/TH.json'
import textBGTH from './pages/bg/TH.json'
import textFacNFoodTH from './pages/facNfood/TH.json'
import textIOTTH from './pages/iot/TH.json'
import textEventTH from './pages/event/TH.json'
import textOrderTH from './pages/order/TH.json'
import textSettingTH from './pages/setting/TH.json'
import textReportTH from './pages/report/TH.json'
import textMonitorTH from './pages/Monitor/TH.json'
import textHotDeskTH from './pages/hotdesk/TH.json'
import textErrorTh from './pages/error/TH.json'

export default {
    login: {
        ...textPageLoginTH
    },
    button: {
        ...textButtonTH
    },
    header: {
        ...textHeaderTH
    },
    room: {
        ...textRoomTH
    },
    advanceSearch: {
        ...textAdvanceSearchTH
    },
    location: {
        ...textLocationTH
    },
    user: {
        ...textUserTH
    },
    role: {
        ...textRoleTH
    },
    profile: {
        ...textProfileTH
    },
    bg: {
        ...textBGTH
    },
    facNfood: {
        ...textFacNFoodTH
    },
    iot: {
        ...textIOTTH
    },
    event: {
        ...textEventTH
    },
    order: {
        ...textOrderTH
    },
    setting: {
        ...textSettingTH
    },
    report: {
        ...textReportTH
    },
    monitor: {
        ...textMonitorTH
    },
    noResult: "ไม่พบข้อมูล",
    hotdesk: {
        ...textHotDeskTH
    },
    error:{
        ...textErrorTh
    },
    home: "หน้าหลัก"
}


// WEBPACK FOOTER //
// ./src/wording/th.js